import moment from "moment";
export function generateWorkingDays(numDays = 14) {
  const days = [];
  let current = moment();

  while (days.length < numDays) {
    days.push(current.format("YYYYMMDD"));

    current.add(1, "day");
  }
  return days;
}



// WEBPACK FOOTER //
// ./src/components/PiScheduler/calendarUtils.js